import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import URLSearchParams from '@ungap/url-search-params'
import { GLOBAL_CONTEXT } from '../../utils'
import '@pan/cortex-app-bar'
import { setIsCollapsed } from '../../actions'
import { connect } from 'react-redux'

export class AppBar extends PureComponent {
  state = { isCollapsed: false }
  barRef = React.createRef()
  tsgId = new URLSearchParams(window.location.search).get('tsg_id')

  onLogout = (e) => {
    this.props.onLogout(e)
  }

  onCortexEvent = (e) => {
    this.props.onCortexEvent(e)
  }

  onAccountSelected = (e) => {
    this.props.onAccountSelected(e)
  }

  navLinkHandler = (detail) => {
    const ref = this.barRef.current
    if (detail === 'logo') {
      if (!this.props.onNavigateHome) {
        return
      }
      this.props.onNavigateHome()
    }
    else if (detail === 'hublink') {
      if (!this.props.onNavigateHub) {
        return
      }
      this.props.onNavigateHub()
      if (ref) {
        ref.openDrawer({ showAppDrawer: false })
      }
    }
    else if (detail === 'viewprofile') {
      if (!this.props.onNavigateProfile) {
        return
      }
      this.props.onNavigateProfile()
      if (ref) {
        ref.showHideUserMenu(false)
      }
    }
  }

  setLogo = () => {
    const ref = this.barRef.current
    const { logoImg, logoImgCompact, name } = this.props
    const { isCollapsed } = this.state

    if (!isCollapsed && logoImg) {
      ref.appBarLogo = logoImg
    }
    else if (isCollapsed && logoImgCompact) {
      ref.appBarLogo = logoImgCompact
    }
    else {
      ref.appTitle = name
    }
  }

  componentDidMount() {
    const ref = this.barRef.current
    if (ref) {
      ref.style.display = this.props.hideAppBar ? 'none' : 'block'
      ref.addEventListener('cortex-sign-out', this.onLogout)
      ref.addEventListener('cortex-account-selected', this.onAccountSelected)
      ref.addEventListener('cortexEvent', this.onCortexEvent)
      ref.linkHandler = (cmp, e) => {
        this.navLinkHandler(cmp)
      }
      const { onNavigateHub, onNavigateProfile } = this.props
      // set default value
      const { appPortalUrl } = GLOBAL_CONTEXT || {}
      if (onNavigateHub) {
        ref.hubLink = '/apps'
      }
      else if (appPortalUrl) {
        ref.hubLink = this.tsgId ? `${appPortalUrl}/hub?tsg_id=${this.tsgId}` : `${appPortalUrl}/apps`
      }
      if (onNavigateProfile) {
        ref._view_profile = '/account-info'
      }
      else if (appPortalUrl) {
        ref._view_profile = `${appPortalUrl}/account-info`
      }
      this.setLogo()
      ref.showAppSwitcher = true
      ref.showFeedbackButton = this.props.showFeedbackButton
      ref.showAnnouncementButton = this.props.showAnnouncementButton
      ref.showUserMenu = true
      ref._isVertical = this.props.isVertical
      ref.letMeCollapse = this.props.allowCollapse ? 'yes' : 'no'
      ref.appSwitcherLabel = this.props.appSwitcherLabel
      ref.collapsed = (isCollapsed) => {
        this.setState({ isCollapsed })
        this.props.setIsCollapsed(isCollapsed)
      }
    }
    this.props.fetchEntitlements()
    this.componentDidUpdate({}) // ensure called once
  }

  componentWillUnmount() {
    const ref = this.barRef.current
    if (ref) {
      ref.removeEventListener('cortex-sign-out', this.onLogout)
      ref.removeEventListener('cortex-account-selected', this.onAccountSelected)
      ref.removeEventListener('cortexEvent', this.onCortexEvent)
      ref.removeEventListener('click', this.onClick)
    }
  }

  componentDidUpdate(prevProps) {
    const ref = this.barRef.current
    if (ref) {
      const {
        className,
        appEntitlements,
        canSwitchAccount,
        onNavigateHub,
        isAuthenticated,
        supportAccountIds,
        selectedAccount,
        user_email,
        user,
        notonorafter,
        fetching,
      } = this.props
      ref.style.display = this.props.hideAppBar ? 'none' : 'block'
      if (isAuthenticated && appEntitlements !== prevProps.appEntitlements) {
        ref._entitlements = appEntitlements || {}
      }
      if (this.tsgId) {
        ref.supportedAccounts = []
      }
      else if (supportAccountIds !== prevProps.supportAccountIds) {
        ref.supportedAccounts = supportAccountIds || []
      }
      if (user_email !== prevProps.user_email || selectedAccount !== prevProps.selectedAccount) {
        const { name = '', accountid } = (!this.tsgId && supportAccountIds[selectedAccount]) || {}
        ref.selectedAccount = accountid
        ref.userData = {
          userName: user,
          companyName: name,
          email: user_email,
        }
      }
      if (notonorafter !== prevProps.notonorafter) {
        ref.notonorafter = notonorafter
      }
      if (!fetching !== !prevProps.fetching) {
        ref.setAppSwitcherLoading(Boolean(fetching))
      }
      if (!canSwitchAccount !== !prevProps.canSwitchAccount) {
        ref._letmeswitch = Boolean(canSwitchAccount)
      }
      if (!onNavigateHub !== !prevProps.onNavigateHub) {
        ref.allowHubLinkEvent = Boolean(onNavigateHub)
        ref.linkHandler = onNavigateHub ? this.navLinkHandler : undefined
      }
      if (className !== prevProps.className) {
        ref.className = className
      }
      this.setLogo()
      ref.collapsed = (isCollapsed) => {
        this.setState({ isCollapsed })
        this.props.setIsCollapsed(isCollapsed)
      }
      ref._isVertical = this.props.isVertical
      ref.showFeedbackButton = this.props.showFeedbackButton
      ref.showAnnouncementButton = this.props.showAnnouncementButton
      ref.showUserMenu = true
      ref.letMeCollapse = this.props.allowCollapse ? 'yes' : 'no'
    }

  }

  render() {
    const { children } = this.props
    return <cortex-app-bar
      ref={this.barRef}
    >{children}</cortex-app-bar>
  }
}

AppBar.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  context: PropTypes.object,
  logoImg: PropTypes.string,
  logoImgCompact: PropTypes.string,
  appEntitlements: PropTypes.object,
  canSwitchAccount: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  user: PropTypes.string,
  user_email: PropTypes.string,
  selectedAccount: PropTypes.number,
  supportAccountIds: PropTypes.array,
  onAccountSelected: PropTypes.func,
  notonorafter: PropTypes.string,
  setSupportAccountIndexHandler: PropTypes.func,
  entitlementFetching: PropTypes.bool,
  fetchEntitlements: PropTypes.func,
  showGlobalMask: PropTypes.func,
  history: PropTypes.object,
  onLogout: PropTypes.func,
  onCortexEvent: PropTypes.func,
  onNavigateHome: PropTypes.func,
  onNavigateHub: PropTypes.func,
  onNavigateProfile: PropTypes.func,
  fetching: PropTypes.bool,
  children: PropTypes.node,
  isVertical: PropTypes.bool,
  appSwitcherLabel: PropTypes.string,
  onCollapsedCb: PropTypes.func,
  hideAppBar: PropTypes.bool,
  setIsCollapsed: PropTypes.func,
  showFeedbackButton: PropTypes.bool,
  showAnnouncementButton: PropTypes.bool,
  allowCollapse: PropTypes.bool,
}

AppBar.defaultProps = {
  appEntitlements: {},
  supportAccountIds: [],
  name: 'App',
  fetching: false,
  isAuthenticated: false,
  entitlementFetching: false,
  canSwitchAccount: false,
  fetchEntitlements: noop,
  onLogout: noop,
  onCortexEvent: noop,
  onAccountSelected: noop,
  onNavigateHome: undefined,
  onNavigateHub: undefined,
  onNavigateProfile: undefined,
  isVertical: false,
  hideAppBar: false,
  appSwitcherLabel: 'All Applications',
  onCollapsedCb: () => {},
  showFeedbackButton: false,
  showAnnouncementButton: false
}

const mapDispatchToProps = (dispatch) => ({
  setIsCollapsed: (isCollapsed) => {
    dispatch(setIsCollapsed(isCollapsed))
  }
})

export default connect(null, mapDispatchToProps)(AppBar)
